export enum USERS {
  LIST = '/users/list',
  ADD = '/users/add',
  EDIT = '/users/edit/:id',
}
